import type { VisibilityConfig } from './types.js'

/**
 * Whether a link shows the deck — the rule the backend's `visibleDocuments`
 * applies: the documents section has to be on and, when the link carries a
 * document allowlist, the deck has to be on it.
 */
export function isDeckShared(
  visibility: VisibilityConfig | null | undefined,
  deckDocumentId: string | undefined
): boolean {
  if (!deckDocumentId) return false
  if (!visibility) return true
  return (
    visibility.sections.includes('documents') &&
    (!visibility.documents || visibility.documents.includes(deckDocumentId))
  )
}
